export const DebugControls = ({showLooks = []}) => (
  <div className="button-row">
    {showLooks.map(({id, name, cb}) =>
      <button key={id} onClick={cb}>{id}: {name}</button>
    )}
  </div>
)
